import { Text } from '@mantine/core';
import clsx from 'clsx';
import { FC } from 'react';

import PlatformAvatar from '@assets/platformavatar.png';

import styles from './index.module.css';

interface IProps {
  infoText?: string;
}
const MainLoader: FC<IProps> = ({ infoText, ...rest }) => {
  return (
    <div className={clsx(styles['loader-container'])} {...rest}>
      <div className={styles.circles}>
        <div className={styles.circle1}></div>
        <div className={styles.circle2}></div>
        <div className={styles.circle3}></div>
      </div>
      <div></div>
      <img className={styles['platfom-avatar']} src={PlatformAvatar} />
      {infoText && <Text className={styles['info-text']}>{infoText}</Text>}
    </div>
  );
};

export default MainLoader;
